import { Col, Label } from "reactstrap";
import TextField from "../../../../common/TextField";
import DatePicker from "../../../../common/DatePicker";
import { useEffect, useState } from "react";
import { H3 } from "../../../../../AbstractElements";
import MobileField from "../../../../common/MobileField";
import Dropdown from "../../../../common/DropDown";
import { useGetRequestQuery } from "../../../../../Hooks/useGetRequestQuery";
import { getClientFactFindDLLService } from "../../../../../Services/PublicPageServices";
import DollarInput from "../../../../common/DollarInput";

export default function FactFindClientDetails({ formData, setFormData }: any) {
    const [clientFactsFindData, setClientFactFindData] = useState<any>(null);

    const {
        data: clientFactFindData,
        refetch: refetchClientFactFindData,
        isLoading: clientFactFindDataLoading,
        isError: clientFactFindDataIsError,
    } = useGetRequestQuery<any>(
        ['getClientFactFindDLL'],
        getClientFactFindDLLService,
        {
            enabled: true,
        }
    );
    useEffect(() => {
        if (clientFactFindData?.data && !clientFactFindDataIsError && !clientFactFindDataLoading) {
            setClientFactFindData(clientFactFindData?.data);
        }
    }, [clientFactFindData]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const splitDropdownValues = (dropdownValues: string) => {
        return dropdownValues ? dropdownValues?.split(',').map(value => value.trim()) : [];
    };


    return (
        <>
            <div className='d-flex flex-wrap item-center mt-4'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <H3 className="heading-color f-w-900  my-2">
                        Client Details
                    </H3>
                </Col>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <H3 className="heading-color f-w-900  my-2">
                        Applicant 1
                    </H3>
                </Col>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <H3 className="heading-color f-w-900  my-2">
                        Applicant 2
                    </H3>
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        First Name
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={1}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2FirstName"
                        value={formData.client2FirstName}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={11}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Surname
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="surname"
                        value={formData.surname}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={2}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2Surname"
                        value={formData.client2Surname}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={12}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Mobile
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <MobileField
                        label=""
                        mobileField="mobile"
                        type="text"
                        value={formData.mobile}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxLength={14}
                        tabIndex={3}

                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <MobileField
                        label=""
                        mobileField="client2Mobile"
                        type="text"
                        value={formData.client2Mobile}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxLength={14}
                        tabIndex={13}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Email
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="email"
                        value={formData.email}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={4}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2Email"
                        value={formData.client2Email}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={14}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Date Of Birth
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <DatePicker
                        label=""
                        name="client1Dob"
                        value={formData.client1Dob}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        tabIndex={5}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <DatePicker
                        label=""
                        name="client2Dob"
                        value={formData.client2Dob}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        tabIndex={15}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Marital Status
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client1MaritalStatus"
                        value={formData.client1MaritalStatus}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[1].dropDownValues : '')}
                        tabIndex={6}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client2MaritalStatus"
                        value={formData.client2MaritalStatus}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[1].dropDownValues : '')}
                        tabIndex={16}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Residency Status
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client1ResidencyStatus"
                        value={formData.client1ResidencyStatus}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[2].dropDownValues : '')}
                        tabIndex={7}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client2ResidencyStatus"
                        value={formData.client2ResidencyStatus}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[2].dropDownValues : '')}
                        tabIndex={17}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Credit Status
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client1CreditStatus"
                        value={formData.client1CreditStatus}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[3].dropDownValues : '')}
                        tabIndex={8}

                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client2CreditStatus"
                        value={formData.client2CreditStatus}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[3].dropDownValues : '')}
                        tabIndex={18}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Dependants
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '60%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client1Dependants"
                        value={formData.client1Dependants}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={9}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Current Address
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client1CurrentAddress"
                        value={formData.client1CurrentAddress}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        enableAddressFinder
                        maxChars={20}
                        tabIndex={9}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2CurrentAddress"
                        value={formData.client2CurrentAddress}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        enableAddressFinder
                        tabIndex={19}

                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Previous Address
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client1PreviousAddress"
                        value={formData.client1PreviousAddress}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        enableAddressFinder
                        maxChars={20}
                        tabIndex={10}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2PreviousAddress"
                        value={formData.client2PreviousAddress}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        enableAddressFinder
                        tabIndex={20}
                    />
                </Col>
            </div>
            <div className='d-flex flex-wrap item-center mt-4'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <H3 className="heading-color f-w-900  my-2">
                        Employment
                    </H3>
                </Col>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <H3 className="heading-color f-w-900  my-2">
                        Applicant 1
                    </H3>
                </Col>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <H3 className="heading-color f-w-900  my-2">
                        Applicant 2
                    </H3>
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Employment Type	                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client1EmploymentType"
                        value={formData.client1EmploymentType}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[4].dropDownValues : '')} 
                        tabIndex={21}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <Dropdown
                        label=""
                        name="client2EmploymentType"
                        value={formData.client2EmploymentType}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        options={splitDropdownValues(clientFactsFindData ? clientFactsFindData[4].dropDownValues : '')}
                        tabIndex={26}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Job Title
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client1JobTitle"
                        value={formData.client1JobTitle}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={22}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2JobTitle"
                        value={formData.client2JobTitle}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={27}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Time in Work
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client1TimeInWorkYear"
                        value={formData.client1TimeInWorkYear}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={23}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2TimeInWorkYear"
                        value={formData.client2TimeInWorkYear}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={28}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Previous Work
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client1PreviousWork"
                        value={formData.client1PreviousWork}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={24}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <TextField
                        label=""
                        type="text"
                        name="client2PreviousWork"
                        value={formData.client2PreviousWork}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        maxChars={20}
                        tabIndex={29}
                    />
                </Col>
            </div>
            <div className='d-flex'>
                <Col className="responsive-col mb-3" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                    <Label className="mt-2">
                        Taxable Income
                    </Label>
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <DollarInput
                        label=""
                        name="client1TaxableIncome"
                        value={formData.client1TaxableIncome}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        limit={8}
                        tabIndex={25}
                    />
                </Col>
                <Col className="responsive-col" xs={12} style={{ width: '30%', paddingInline: '2px' }}>
                    <DollarInput
                        label=""
                        name="client2TaxableIncome"
                        value={formData.client2TaxableIncome}
                        setValue={handleValueChange}
                        design="flex"
                        passCol='col-12'
                        limit={8}
                        tabIndex={30}
                    />
                </Col>
            </div>
        </>
    )
}